<template>
  <div class="fixed inset-0 z-[9999] flex flex-col items-center justify-between bg-[#f3fafc] px-8 pt-16 pb-10 overflow-y-auto">

    <!-- Soft blobs -->
    <div class="absolute top-0 right-0 w-64 h-64 bg-primary-100 rounded-full blur-3xl opacity-60 pointer-events-none -translate-y-1/2 translate-x-1/2"></div>
    <div class="absolute bottom-0 left-0 w-64 h-64 bg-primary-100 rounded-full blur-3xl opacity-60 pointer-events-none translate-y-1/2 -translate-x-1/2"></div>

    <!-- Logo -->
    <div class="relative z-10 flex flex-col items-center">
      <img src="@/assets/images/logo/light.png" alt="Concorsando" class="max-w-[200px]" />
    </div>

    <!-- Center: icon + text -->
    <div class="relative z-10 flex flex-col items-center text-center gap-6">
      <!-- App image -->
      <img
        src="@/assets/images/logo/logo-app.png"
        alt="Concorsando app"
        class="w-40 object-contain drop-shadow-xl rounded-3xl"
      />

      <div>
        <h1 class="text-gray-900 text-2xl font-black mb-2 tracking-tight">Usa l'app ufficiale</h1>
        <p class="text-gray-500 text-sm leading-relaxed max-w-[260px]">{{ subtitle }}</p>
      </div>

      <!-- Social proof -->
      <div class="flex items-center gap-2 bg-primary-50 border border-primary-100 px-4 py-2 rounded-full">
        <i class="mdi mdi-account-group text-primary-500 text-base"></i>
        <span class="text-primary-700 text-xs font-semibold">Già scelto da oltre 3.000.000 concorsisti</span>
      </div>
    </div>

    <!-- Bottom: badge + note -->
    <div class="relative z-10 flex flex-col items-center gap-4">
      <a :href="storeUrl" class="block transition-transform active:scale-95">
        <img
          :src="badgeImage"
          :alt="badgeAlt"
          class="h-[52px] object-contain"
        />
      </a>
      <p class="text-gray-400 text-xs text-center max-w-[220px] leading-relaxed">
        Per usare la versione web visita il sito dal browser del tuo PC.
      </p>
    </div>

  </div>
</template>

<script>
import appStoreBadge from '@/assets/images/new-image/appStore.png'
import googlePlayBadge from '@/assets/images/new-image/googlePlay.png'
import appGalleryBadge from '@/assets/images/new-image/appGallery.png'

const STORE_CONFIG = {
  isMobileAgiPhone: {
    subtitle: "Per il tuo iPhone o iPad esiste un'app dedicata disponibile sull'App Store.",
    badgeImage: appStoreBadge,
    badgeAlt: 'Scarica su App Store',
    storeUrl: 'https://itunes.apple.com/it/app/concorsando.it/id543489205',
  },
  isMobileAgiHMS: {
    subtitle: "Per il tuo dispositivo Huawei esiste un'app dedicata disponibile su AppGallery.",
    badgeImage: appGalleryBadge,
    badgeAlt: 'Scarica su AppGallery',
    storeUrl: 'https://appgallery.huawei.com/#/app/C101496801?sharePrepath=ag&locale=it_IT&source=appshare&subsource=C10149680',
  },
  isMobileAgiAndroid: {
    subtitle: "Per il tuo smartphone Android esiste un'app dedicata disponibile su Google Play.",
    badgeImage: googlePlayBadge,
    badgeAlt: 'Scarica su Google Play',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.app.concorsando&hl=it',
  },
}

export default {
  name: 'MobileStorePage',
  props: {
    mobileStatus: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
  computed: {
    config() {
      return STORE_CONFIG[this.mobileStatus.type] || STORE_CONFIG.isMobileAgiAndroid
    },
    subtitle()   { return this.config.subtitle },
    badgeImage() { return this.config.badgeImage },
    badgeAlt()   { return this.config.badgeAlt },
    storeUrl()   { return this.config.storeUrl },
  },
}
</script>
